/**
 * @file Error.js
 *
 * @author Alexandra Marginean <alexia@studyportals.com>
 * @author Rob Janssen <rob@studyportals.com>
 * @author Danko Adamczyk <danko@studyportals.com>
 * @version 1.0.0
 * @copyright © 2015 StudyPortals B.V., all rights reserved.
 */

const ErrorPage = {
	wrapper: null,

	init: function () {
		this.wrapper = document.getElementById('Error');

		if (!this.wrapper) {
			console.debug('Error wrapper not found');
			return;
		}

		// Check the error status code.

		var httpStatusCode = this.wrapper.dataset.dataStatusCode;

		if (httpStatusCode === '503') {
			this.handleTemporarilyUnavailable();
			return;
		}

		console.debug('HTTP status ' + httpStatusCode + ' found, no action taken.');
	},

	/**
	 * Handle 503 page, trying to load the page again after 5s.
	 */

	handleTemporarilyUnavailable: function () {
		// Check for loading placeholder (stage 1)

		var loadingWrapper = this.wrapper.querySelector('.LoadingPagePlaceholder');
		if (!loadingWrapper) {
			console.error('ErrorPage.handleTemporarilyUnavailabe: .LoadingPagePlaceholder not found');
			return;
		}

		//Check for unavailable placeholder (stage 2)

		var reloadWrapper = this.wrapper.querySelector('.PageUnavailablePlaceholder');
		if (!reloadWrapper) {
			console.error('ErrorPage.handleTemporarilyUnavailabe: .PageUnavailablePlaceholder not found');
			return;
		}

		// Hide the placeholder in advance.

		reloadWrapper.classList.add('Hidden');

		var url = new URL(window.location);
		var retryProperty = 'retry';

		// If a reload was already done..

		if (url.searchParams.get(retryProperty) !== null) {
			// Change the page title

			var title = document.title;
			var parts = title.split(' - ');
			var portalName = parts.pop();
			var text = reloadWrapper.dataset.dataText;
			document.title = text + ' - ' + portalName;

			// Retry flag has been set.

			loadingWrapper.classList.add('Hidden');
			reloadWrapper.classList.remove('Hidden');

			// Remove retry flag.

			url.searchParams.delete(retryProperty);

			// On clicking the reload button, go to a "clean" URL.

			this.wrapper.addEventListener('click', function (event) {
				if (event.target.nodeName === 'BUTTON' && event.target.classList.contains('Reload')) {
					window.location.replace(url);
				}
			});
		} else {
			// First time loading - add the retry flag.

			url.searchParams.set(retryProperty, '1');

			var title = document.title;
			var parts = title.split(' - ');
			var portalName = parts.pop();
			var text = loadingWrapper.dataset.dataText;
			document.title = text + ' - ' + portalName;

			setTimeout(function () {
				window.location.replace(url);
			}, 5000);
		}
	}
};

document.addEventListener('DOMContentLoaded', function () {
	ErrorPage.init();
});
